/* eslint-disable */

import request from '@/utils/request'

export function getListHouseKeepingServiceApi(query) {
  return request({
    url: '/chamber-service/v1/sub-booking-service/booking',
    method: 'get',
    params: query
  })
}

export function getSubBookingServiceInvoice(id) {
  return request({
    url: `/chamber-service/v1/sub-booking-service/invoice/${id}`,
    method: 'get'
  })
}

export function getHouseKeepingServiceInvoicesApi(query) {
  return request({
    url: '/chamber-service/v1/sub-booking-service/invoice',
    method: 'get',
    params: query
  })
}

export function addHouseKeepingServiceInvoicesApi(query) {
  return request({
    url: '/chamber-service/v1/sub-booking-service',
    method: 'post',
    data: query
  })
}

export function updateHouseKeepingServiceInvoicesApi(query) {
  return request({
    url: `/chamber-service/v1/sub-booking-service/${query.id}`,
    method: 'put',
    data: query
  })
}

export function deleteHouseKeepingServiceInvoicesApi(query) {
  return request({
    url: '/chamber-service/v1/sub-booking-service',
    method: 'delete',
    data: query
  })
}
